import React, { useContext, useEffect, useState } from "react";
import LottieAnimation from "./Lottie";
import smartRobotLoading from './robot-find-inspiration.json';
import smartRobot from './smart-robot.json';
import ChatContext from "./context";
import SessionUsage from "./components/SessionUsage";

const Sidebar = () => {
  const {store} = useContext(ChatContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=>{
    setIsLoading(store.isLoading)
  },[store]);

  return (
    <div className="flex flex-col min-h-screen md:h-screen p-4 md:p-6 md:basis-1/3 text-white bg-gradient-to-b from-[#4940A9] to-[#AE2DC7] shadow-[4px 0px 9.2px 0px rgba(115, 24, 143, 0.24)] rounded-[0px 40px 40px 0px] md:overflow-hidden">
      {/* Title at top */}
      <div className="flex flex-col flex-shrink-0 p-2 md:p-3 gap-1 md:gap-2">
        <h1 className="font-plus-jakarta-sans text-[28px] md:text-[40px] text-[#FFD700] font-medium leading-tight md:leading-[44.48px] text-center">
          Zucky AI
        </h1>
        <h2 className="font-plus-jakarta-sans text-[16px] md:text-[22px] text-white font-medium leading-tight text-center">
          Your Everyday Intelligent Companion
        </h2>
      </div>

      {/* Lottie fills remaining space and resizes to fit */}
      <div className="flex-1 min-h-0 flex items-center justify-center py-2 w-full">
        <div className="w-full h-full max-w-[400px] max-h-[320px] min-h-[120px] flex items-center justify-center">
          <LottieAnimation
            src={isLoading ? smartRobotLoading : smartRobot}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </div>

      {/* Usage and description at bottom, no gap */}
      <div className="flex flex-col gap-2 md:gap-3 flex-shrink-0 mt-auto">
        <SessionUsage />
        <div className="flex text-black p-2 md:p-3 rounded-[25px] opacity-100 bg-[#D5D5D580] backdrop-blur-[27px] flex-shrink-0">
          <p className="font-plus-jakarta-sans text-[12px] md:text-[16px] font-medium leading-relaxed text-center">
            Meet Zucky, your intelligent companion built to elevate your digital experience! Inspired by the Arabic word for &quot;intelligent,&quot; Zucky combines advanced AI with a touch of personality, bringing smart, seamless conversations right to your fingertips!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
